module.exports = __webpack_public_path__ + "img/nerostarx_blueprint.26943f43.jpg";